import getApiUrl from "../helpers/getApiUrl";
import getEnvironment from "../helpers/getEnvironment";

const deleteProxyBid = async (
  vrm: string | string[],
  isToUseAuthZero: boolean = false,
  accessToken?: string
) => {
  const isLocalhost = !["preview", "production"].includes(getEnvironment());
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (!isToUseAuthZero && isLocalhost && process.env.token) {
    headers.Authorization = `Bearer ${process.env.token}`;
  }

  const res = await fetch(
    getApiUrl(
      `${process.env.apiFunctionUrl}/api/bid/proxy/${vrm}`,
      isToUseAuthZero
    ),
    {
      method: "DELETE",
      headers,
    }
  );

  if (res.status === 200) {
    // try to deserialize and on failure return status code
    return res.json().catch(() => res);
  }

  return res;
};

export default deleteProxyBid;
